import { Controller } from '@hotwired/stimulus'

// Single-open FAQ accordion. Each item has a trigger button (aria-expanded,
// aria-controls) and a panel; opening one closes the others.
export default class extends Controller<HTMLElement> {
  static targets = ['item']

  declare readonly itemTargets: HTMLElement[]

  toggle(event: Event): void {
    const button = event.currentTarget as HTMLElement
    const item = button.closest('[data-accordion-target="item"]') as HTMLElement
    const willOpen = button.getAttribute('aria-expanded') !== 'true'

    this.itemTargets.forEach((other) => this.setOpen(other, false))
    if (willOpen) this.setOpen(item, true)
  }

  private setOpen(item: HTMLElement, open: boolean): void {
    const button = item.querySelector('[aria-controls]') as HTMLElement
    const panel = item.querySelector('[data-accordion-panel]') as HTMLElement
    const sign = item.querySelector('[data-accordion-sign]') as HTMLElement | null

    button.setAttribute('aria-expanded', String(open))
    panel.hidden = !open
    if (sign) sign.textContent = open ? '–' : '+'
  }
}
